<style lang="scss" scoped>
    img.bullet-img {
        width: 2em;
        height: 2.0em;
    }
    .title {
        font-size: 2.0em;
        color: #223264;
    }
    .intro-text {
        color: #223264;
    }
    img.bts-logo {
        width: 250px;
    }
    .nav-link {
        padding: 1em !important;
    }
</style>

<template>
    <div class="component-container">
        <div class='container'>
            <div class='row align-items-end'>
                <div class='title col-sm-6 text-left'>Build the Skills</div>
                <div class='col-sm-6 text-right'><img :src = "$basePath + '/images/provider_trainings/bts-logo.png'" class='bts-logo' /></div>
            </div>
            <div class='row pb-5'>
                <div class='col-sm-12 intro-text'>
                    Go NAPSACC Build the Skills with Be Active Kids is a
                    train-the-trainer model, allowing 
                    consultants and child care providers to dive deeper into Go NAPSACC evidence-based practices. 
                    Once certified, Go NAPSACC consultants can deliver Be Active Kids training to child care 
                    providers, helping them increase their comfort and competence in providing high quality 
                    physical activity and motor skill opportunities. Interested in becoming a certified Be Active Kids 
                    trainer?... Get started with step 1 below.
                </div>
            </div>
        </div>

        <ul class="nav nav-tabs nav-fill">
            <li class="nav-item">
                <a class="nav-link active" data-toggle="tab" href="#bts_0">
                    <span><img :src="$basePath + '/images/provider_trainings/bts-bullet-1.png'" class="bullet-img mx-2" />Complete Be Active Kids Trainer Certification</span>
                </a>
            </li>
            <li class="nav-item" >
                <a class="nav-link" :class="{ disabled: !isStepTwoEnabled }" data-toggle="tab" href="#bts_1">
                    <span><img :src="$basePath + '/images/provider_trainings/bts-bullet-2.png'" class="bullet-img mx-2" />Lead Provider Training Sessions</span>
                </a>
            </li>
        </ul>

        <div class="tab-content">
            <div class="collapse tab-pane active" id="bts_0" role="tabpanel">
                <certification-page @select-content="selectContent" :enable-certificate="isStepTwoEnabled"></certification-page>
            </div>
            <div class="collapse tab-pane" id="bts_1" role="tabpanel">
                <provider-training-page @select-content="selectContent"></provider-training-page>
            </div>
        </div>
    </div>
</template>

<script>
  import ProviderTrainingPage from './pages/ProviderTraining';
  import CertificationPage from "./pages/TrainerCertification";
  
    export default {
        components: {
            CertificationPage,
            ProviderTrainingPage,
        },
        props: {
            stepTwoEnabled: {
                required: false,
                type: Boolean,
                default: false,
            },
            user: {
                required: true,
                type: Object,
                default: null,
            },
        },
        data() {
            return {
                currentTab: 0,
                isStepTwoEnabled: this.stepTwoEnabled,
            }
        },
        methods: {
            selectContent(component) {
                this.$emit('select-content', component);
            },
            getAssessmentContext() {
                let vm = this;
                axios.get('/build-the-skills/assessment/user/' + this.user.id + '/context')
                    .then(response => {
                        vm.isStepTwoEnabled = !!response.data.context.response.finalized_at;
                    });
            }
        },
        mounted() {
            this.getAssessmentContext();
        },
        watch: {
            stepTwoEnabled: function(newVal, oldVal) {
                this.isStepTwoEnabled = newVal;
            }
        }
    }
</script>